<template>
  <div class="container-box">
    <div class="center-container">
      <div class="center-content">
        <el-form class="form-container" :model="ruleAdd" :rules="rules" ref="ruleAdd" status-icon>
          <el-radio-group class="radio-content" @change="radioChange" v-model="ruleAdd.type">
            <el-radio class="radio-list" :label="1">市场人员</el-radio>
            <el-radio class="radio-list" :label="2">工程师</el-radio>
            <el-radio class="radio-list" :label="5">收发人员</el-radio>
            <el-radio class="radio-list" :label="16">财务</el-radio>
          </el-radio-group>
          <el-form-item class="input-list" label="姓名" prop="name">
            <el-input type="text" placeholder="请输入姓名" v-model="ruleAdd.name"></el-input>
          </el-form-item>
          <el-form-item class="input-list" label="用户名" prop="account">
            <el-input type="text" placeholder="请输入用户名" v-model="ruleAdd.account"></el-input>
          </el-form-item>
          <el-form-item class="input-list" label="区域" prop="city_id">
            <el-select v-model="ruleAdd.city_id" placeholder="请选择区域">
              <el-option
                v-for="item in citys"
                :key="item.city_id"
                :label="item.city_name"
                :value="item.city_id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="input-list" label="密码" prop="password">
            <el-input type="password" placeholder="请输入密码" v-model="ruleAdd.password"></el-input>
          </el-form-item>
          <el-form-item class="input-list" label="确认密码" prop="password2">
            <el-input type="password" placeholder="请输入密码" v-model="ruleAdd.password2"></el-input>
          </el-form-item>
          <el-checkbox-group v-if="ruleAdd.type === 2" @change="checkChange" class="check-content" v-model="ruleAdd.checkList">
            <el-checkbox class="check-list" label="核验"></el-checkbox>
            <el-checkbox class="check-list" label="批准"></el-checkbox>
          </el-checkbox-group>
          <el-form-item class="btn-list">
            <el-button class="login-btn" @click="submitForm('ruleAdd')">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script type='text/ecmascript-6'>
import { accountRule, passwordRule, name, cityidRule} from 'common/js/loginValidate'
export default {
  data () {
    var passwordConfirm = (rule, value, callback) => {
      if (!value) {
        callback(this.$message({
          message: '确认密码不能为空！',
          type: 'error',
          customClass: 'msg-position',
          showClose: true
        }))
      }
      if ( value !== this.ruleAdd.password) {
        callback(this.$message({
          message: '两次密码输入不一致',
          type: 'error',
          customClass: 'msg-position',
          showClose: true
        }))
      } else  {
        callback()
      }
    }
    return {
      ruleAdd: {
        type: 1,
        name: '',
        account: '',
        password: '',
        password2: '',
        checkList: [],
        city_id: ''
      },
      rules: {
        account: [
          { validator: accountRule, trigger: ['blur'] }
        ],
        password: [
          { validator: passwordRule, trigger: 'blur' }
        ],
        name: [
          { validator: name, trigger: 'blur'}
        ],
        password2: [
          { validator: passwordConfirm, trigger: 'blur'}
        ],
        city_id: [
          { validator: cityidRule, trigger: 'blur'}
        ]
      },
      citys: []
    }
  },
  created () {
    if (this.$route.query.type) {
      this.ruleAdd.type = Number(this.$route.query.type)
    }
    this.getLabCities()
  },
  methods: {
    radioChange(type) { // 选择 单选框 添加人员的类型
      this.ruleAdd.type = type
    },
    checkChange (e) { // 选择 核验和批准 添加 人员 能够批准 还是能够核准
      this.ruleAdd.checkList = e
    },
    submitForm(formName) {
      let that = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$api.saveUser({
            type: this.ruleAdd.type,
            name: this.ruleAdd.name,
            user: this.ruleAdd.account,
            password: this.ruleAdd.password,
            measure_type: this.ruleAdd.checkList,
            city_id: this.ruleAdd.city_id
          }).then(res => {
            if (res.data.msg === true) {
              that.$message({
                type: 'success',
                message: '用户保存成功！！',
                customClass: 'msg-position',
                showClose: true
              })
            } else {
              that.$message({
                message: res.data.error,
                type: 'error',
                customClass: 'msg-position',
                showClose: true
              })
            }
          }).catch(err => {
            that.$message({
              type: 'error',
              message: err,
              customClass: 'msg-position',
              showClose: true
            })
          })
        }
      })
    },
    getLabCities() { // 获取所有的区域
      let that = this
      that.$api.getLabCities({
      }).then(res => {
        if (res.data.length > 0) {
          that.citys = [...res.data]
        } else {
          that.$message({
            message: '区域获取错误！',
            type: 'error',
            customClass: 'msg-position',
            showClose: true
          })
        }
      })
    }
  },
  components: {
  }
}
</script>

<style lang='stylus' rel='stylesheet/stylus'>
@import '~common/stylus/mixin.styl'
.container-box
  /* height:100%;
  display:flex;
  flex-direction: column; */
  /* height:100%; */
  .center-container
    height:100%;
    padding: 0rem 1rem 1rem 1rem;
    display: flex;
    flex-direction: column;
    .center-content
      flex:1;
      background:#fff;
      /* height:100%; */
      display: flex;
      justify-content: center;
      align-items: center;
      .form-container
        margin: 2rem 0;
        border: 0.05rem solid #ececec;
        padding: 2rem 4.5rem;
        .input-list
          display: flex;
          margin-bottom: 1rem;
          &.is-error
            .el-form-item__content
              .el-input
                .el-input__inner
                  border: 0.05rem solid #EF757A;
          .el-form-item__label
            color:#474747;
            font-size:0.7rem
            flex: 0 0 4rem;
            text-align: left;
          .el-form-item__content
            position:relative;
            height:2rem;
            width: 20rem;
            .el-select
              width: 100%;
            .el-input
              height:2rem;
              .el-input__inner
                padding: 0 0.8rem;
                border: 0.05rem solid #cfcfcf;
            .el-form-item__error
              /* top:0.5rem; */
              left: 0.8rem;
              background:#fff;
              color:#EF757A;
        .btn-list
          width:100%;
          padding: 0px 3rem;
          .el-form-item__content
              width: 100%;
            .login-btn
              background:#1D489E;
              width:100%;
              span
                color:#fff;
        .radio-content
          height:2rem;
          margin-bottom: 1rem;
          display: flex;
          justify-content: center;
          align-items: center;
          .radio-list
            color: #666;
            font-size: 0.7rem;
            .el-radio__label
              color:#666;
            &.is-checked
              .el-radio__label
                color:#666;
            .el-radio__input
              .el-radio__inner
                border:0;
                width: 1rem;
                height:1rem;
                background-color:#fff;
                bg-image('~assets/radio.png');
            &.is-checked
              .el-radio__inner
                bg-image('~assets/radio_checked.png');
        .check-content
          height:2rem;
          margin-bottom: 1rem;
          display: flex;
          justify-content: center;
          align-items: center;
          .check-list
            &.is-checked
            .el-checkbox__input
              &.is-checked
                .el-checkbox__label
                  color:#666;
                .el-checkbox__inner
                  background-color:#fff;
                  bg-image('~assets/checked.png');
                  &::after
                    display:none;
              .el-checkbox__inner
                width:0.8rem;
                height:0.8rem;
                background-color:#fff;
                border:0px;
                bg-image('~assets/check.png');

</style>
